module.exports = __webpack_public_path__ + "static/img/DST_H5.6c857c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/DST_H5.png
// module id = hALd
// module chunks = 34